<script>
import { mapGetters } from 'vuex';
import { BlockProps } from '../models/styleModels';

export default {
  name: 'block',
  props: {
    blockOfZone: { type: Boolean, default: false },
    guid: { type: String },
    visible: { type: Boolean, default: true },
    blockProps: { type: Object, default: () => {} },
    identification: { type: String, default: '' }
  },
  computed: {
    ...mapGetters(['getProductPrice', 'selectedLanguage']),
    myBlockProps() {
      return new BlockProps(this.blockProps);
    },
    hasPaginableChildren() {
      // Only allow to swipe on the last paginable child
      return this.$children.some((child) => child.isPaginableContentBlock || child.hasPaginableChildren);
    },
    hasScrollableChildren() {
      return this.$children.some((child) => child.isScrollableContentBlock || child.hasScrollableChildren);
    },
    isPaginableContentBlock() {
      return false;
    },
    isScrollableContentBlock() {
      return false;
    }
  }
};
</script>
